function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.5625 7.21875C27.5625 5.04 29.3213 3.28125 31.5 3.28125C33.6787 3.28125 35.4375 5.04 35.4375 7.21875V10.29C43.68 12.075 49.875 19.425 49.875 28.2187V43.9687L55.125 49.2187V51.8437H7.875V49.2187L13.125 43.9687V28.2187C13.125 19.425 19.32 12.075 27.5625 10.29V7.21875ZM31.5 15.0937C38.745 15.0937 44.625 20.9737 44.625 28.2188V46.5938H18.375V28.2188C18.375 20.9737 24.255 15.0937 31.5 15.0937ZM26.2763 54.495C26.2763 57.3825 28.6125 59.7188 31.5 59.7188C34.3875 59.7188 36.7238 57.3825 36.7238 54.495H26.2763Z",
  fill: "#749DFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8751 20.3443H34.1251V30.8443H28.8751V20.3443Z",
  fill: "#A7EAFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8751 36.0943H34.1251V41.3443H28.8751V36.0943Z",
  fill: "#A7EAFF"
});

var SvgCustomerAlertIcon = function SvgCustomerAlertIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomerAlertIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-alert-icon.865197d0.svg";
export { ForwardRef as ReactComponent };